import axios from "axios";
import router from "@/router";

const API_URL = process.env.VUE_APP_API_URL;

const api = axios.create({
  baseURL: API_URL + "/api",
  withCredentials: true,
});

let refreshPromise = null;

function isAuthApiRoute(url = "") {
  return (
    url.includes("/auth/login") ||
    url.includes("/auth/refresh") ||
    url.includes("/auth/logout")
  );
}

function isResetValidateRoute(url = "") {
  return url.includes("/auth/reset/validate");
}

function routeRequiresAuthSafely() {
  try {
    const fullPath =
      window.location.pathname + window.location.search + window.location.hash;

    const resolved = router.resolve(fullPath);
    return (resolved.matched || []).some((m) => m.meta?.requiresAuth === true);
  } catch (e) {
    return true;
  }
}

function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = api
      .post("/auth/refresh", null)
      .finally(() => (refreshPromise = null));
  }
  return refreshPromise;
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;

    if (!response || !config) throw error;
    if (response.status !== 401) throw error;

    if (config._retry) throw error;
    config._retry = true;

    if (isAuthApiRoute(config.url || "")) throw error;
    if (isResetValidateRoute(config.url || "")) throw error;

    if (!routeRequiresAuthSafely()) {
      throw error;
    }

    try {
      await refreshSession();
      return api(config);
    } catch (e) {
      window.dispatchEvent(new Event("mm:auth:logout"));
      throw error;
    }
  },
);

export default api;
